/* src/app/features/contratacao/limite-contratacao/limite-contratacao-listagem.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.negativo {
  color: red;
}
/*# sourceMappingURL=limite-contratacao-listagem.component.css.map */
